var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnfoldMoreSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,0C10.4863281,0,6,4.4858398,6,10v12c0,5.5141602,4.4863281,10,10,10s10-4.4858398,10-10V10 C26,4.4858398,21.5136719,0,16,0z M24,22c0,4.4111328-3.5888672,8-8,8s-8-3.5888672-8-8V10c0-4.4111328,3.5888672-8,8-8 s8,3.5888672,8,8V22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,23.5859375l-3.2929688-3.2929688l-1.4140625,1.4140625l4,4C15.4882812,25.9023438,15.7441406,26,16,26 s0.5117188-0.0976562,0.7070312-0.2929688l4-4l-1.4140625-1.4140625L16,23.5859375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2929688,6.2929688l-4,4l1.4140625,1.4140625L16,8.4140625l3.2929688,3.2929688l1.4140625-1.4140625l-4-4 C16.3164062,5.9023438,15.6835938,5.9023438,15.2929688,6.2929688z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfoldMoreSmall);
export default __webpack_public_path__ + "static/media/unfold-more--small.6cd2a364c8fa7255dbff1aa5399fc928.svg";
export { ForwardRef as ReactComponent };